module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-09.55524b05.svg";